import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
        user: '',
        isAuthenticated: false
}

const mutations = {
  setUser(state,user)
  {
      state.user=user;
      state.isAuthenticated=true;
  },
  logOutUser(state)
  {
      state.user=null;
      state.isAuthenticated=false;
  },
  setIsAuthenticated(state,isAuthenticated)
  {
      state.isAuthenticated=isAuthenticated;
  }
}

const actions = {
  setUser(state,user)
  {
    state.commit('setUser',user)
  },
  logOutUser(state)
  {
    state.commit('logOutUser')
  },
  setIsAuthenticated(state,isAuthenticated)
  {
    state.commit('setIsAuthenticated',isAuthenticated)
  }
}
const getters = {
   user:state=>state.user,
   isAuthenticated:state=>state.isAuthenticated
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
